import React, { FC } from "react";
import { Box, Text } from "@dxp-feed/ui";
import { IAvailableOffer } from "@/utils/redux/favOffers";
import AvailableOffersSection from "./AvailableOffersSection";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";


export interface IAutomaticAddedOffers {
  automaticAddedOffers: IAvailableOffer[];
}

export const AutomaticAddedOffers: FC<IAutomaticAddedOffers> = ({ automaticAddedOffers }) => {
  const { uid } = useAppSelector((state) => state.gigyaslice);

  return (
    <Box as="div">
      <Box as="div" className="text-base font-bold text-brandSecondary py-3 px-6">
        Other Eligible Scene+ Offers
      </Box>

      {automaticAddedOffers?.map((offer) => {
        return (
          <AvailableOffersSection
            banner={offer?.banner}
            id={offer?.id}
            offer_description={uid && offer?.offer_description ? JSON.parse(offer?.offer_description) : offer}
            offer_id={offer?.offer_id}
            offer_type={offer?.offer_type}
            uid={offer?.uid}
            trashButton={false}
            key={offer?.id}
          />
        );
      })}
    </Box>
  );
};


